import React, { useState } from 'react'

import { Tabs } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import Login from './Login'
import Register from './Register'

// Seller landing page (_slow_sellers.slim) signup card. Stays on the password
// Login/Register forms: Register's `source` becomes new_user[source], which
// RegistrationsController maps to user.segment (:seller for 'sell-3d-models');
// the OTP AuthFlow has no equivalent attribution path.
function SignUpWrapper({ activeTabId = '', customId = '', source = '', locale = 'en' }) {
  const [activeId, setActiveId] = useState(activeTabId || 'login')

  const translate = (key) => I18n.t(key, { ns: 'rails', lng: locale })

  const loginTab = {
    title: translate('navigation.user.login'),
    id: 'login',
    expand: true,
    contents: <Login customId={customId} captchaId="navbar-captcha" locale={locale} />,
  }
  const registerTab = {
    title: translate('navigation.user.register'),
    id: 'register',
    expand: true,
    contents: <Register customId={customId} source={source} captchaId="navbar-captcha" locale={locale} />,
  }

  return (
    <div className="card">
      <Tabs
        className="auth-tabs"
        expand
        activeTabId={activeId}
        onClick={setActiveId}
        tabs={[
          loginTab,
          registerTab,
        ]}
      />
    </div>
  )
}

SignUpWrapper.propTypes = {
  activeTabId: string,
  customId: string,
  source: string,
  locale: string,
}

export default SignUpWrapper
